// removed by extract-text-webpack-plugin
module.exports = {"bp-tablet":"(max-width: 1200px)","legalMentions":"src-pages----legal-mentions-module---legalMentions---1SSLN"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/legal-mentions.module.css
// module id = 257
// module chunks = 40078938568781